<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="7" class="main-part d-none d-md-none d-lg-flex">
          <div class="d-flex">
            <v-img src="@/assets/logo-projeto.png" contain></v-img>
          </div>
        </v-col>
        <v-col cols="12" lg="5" class="login-part d-flex align-center justify-center">
          <v-row no-gutters class="align-start">
            <v-col cols="12" class="login-part d-flex align-center justify-center flex-column">
              <div class="login-wrapper pt-16 pt-sm-0">
                <v-container>
                  <v-row class="flex-column">
                    <v-col>
                      <p class="login-slogan text-center font-weight-medium my-10">Pedido de Solicitação Nova de Senha</p>
                      <p class="font-weight-medium my-10">Foi enviado um e-mail para: {{this.emailMensagem}}</p>
                      <p class="font-weight-medium my-10">Confira sua caixa de entrada para criar uma nova senha</p>
                    </v-col>
                    <v-col>
                      <v-btn
                        class="text-capitalize"
                        block
                        large
                        color="primary"
                        @click="pushLogin">
                        Ok
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-col>
          </v-row>          



        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'MensagemSenha',
  props: ['emailMensagem'],
  data() {
    return {
    }
  },
  methods: {
    pushLogin() {
      this.$router.push({name: 'Login'});          
    }
  },
  computed: {
  },
  created() {
  },
}

</script>

<style src="./MensagemSenha.scss" lang="scss"/>
